import React from 'react';
import { Search, Filter, User } from 'lucide-react';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface SearchFiltersProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  filterType: string;
  setFilterType: (value: string) => void;
  filterPerson: string;
  setFilterPerson: (value: string) => void;
  scheduleTypes: string[];
  allPeople: {id: string, name: string, type: 'doctor' | 'staff'}[];
}

const SearchFilters: React.FC<SearchFiltersProps> = ({
  searchTerm,
  setSearchTerm,
  filterType,
  setFilterType,
  filterPerson,
  setFilterPerson,
  scheduleTypes,
  allPeople
}) => {
  return (
    <div className="flex flex-col md:flex-row gap-4">
      <div className="relative flex-1">
        <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search schedules..."
          className="pl-8"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="flex flex-col sm:flex-row gap-2">
        <div className="w-full sm:w-[180px]">
          <Select value={filterType} onValueChange={setFilterType}>
            <SelectTrigger>
              <div className="flex items-center gap-2">
                <Filter className="h-4 w-4" />
                <SelectValue placeholder="Filter by type" />
              </div>
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Types</SelectItem>
              {scheduleTypes.map(type => (
                <SelectItem key={type} value={type}>{type}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="w-full sm:w-[220px]">
          <Select value={filterPerson} onValueChange={setFilterPerson}>
            <SelectTrigger>
              <div className="flex items-center gap-2">
                <User className="h-4 w-4" />
                <SelectValue placeholder="Filter by person" />
              </div>
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All People</SelectItem>
              <SelectItem value="none">Unassigned</SelectItem>
              {allPeople.length > 0 && (
                <>
                  <SelectItem value="header-doctors" disabled>
                    --- Doctors ---
                  </SelectItem>
                  {allPeople
                    .filter(p => p.type === 'doctor')
                    .map(person => (
                      <SelectItem key={person.id} value={`doctor:${person.id}`}>
                        {person.name}
                      </SelectItem>
                    ))}
                  <SelectItem value="header-staff" disabled>
                    --- Staff ---
                  </SelectItem>
                  {allPeople
                    .filter(p => p.type === 'staff')
                    .map(person => (
                      <SelectItem key={person.id} value={`staff:${person.id}`}>
                        {person.name}
                      </SelectItem>
                    ))}
                </>
              )}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default SearchFilters;
